import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=debb576e&scoped=true&"
import script from "./NotificationForm.vue?vue&type=script&lang=js&"
export * from "./NotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationForm.vue?vue&type=style&index=0&id=debb576e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debb576e",
  null
  
)

export default component.exports